import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

import $ from 'jquery'

import axios from 'axios'
import querystring from 'querystring'

import {
    userLogout,
} from '../../modules/user'

import {
    resetOrder,
} from '../../modules/order'

import {
    resetQuotation,
} from '../../modules/quotation'

import {
    setProductType,
    setConnectorType,
    setFiberType,
    setCableType,
    setCableLength,
    setPackagingType,
    setProduct
} from '../../modules/order'

import {
    setConnectorItems
} from '../../modules/connectorTypes'

import {
    setItems as setFiberItems
} from '../../modules/fiberTypes'

import {
    setItems as setCableItems
} from '../../modules/cableTypes'

import {
    setItems as setPackagingItems
} from '../../modules/packagingTypes'

class Header extends React.Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);
        this.state = {
            article_number: "",
            error_article_number: false
        };

        this.showBasket = this.showBasket.bind(this);
        this.showProductDetails = this.showProductDetails.bind(this);
    }

    showBasket() {
        $(".basket-popup").fadeIn();
        $(".extender").fadeOut();
    }

    showProductDetails() {
        $('.extender').fadeToggle();
    }

    logout(){
        const { history } = this.props;

        const _this = this;

        axios({
            method: 'get',
            url: _this.props.config.api_path+'logout'
        })
        .then(function (response) {
            window.location.href = "/";
            _this.props.userLogout();
            _this.props.resetOrder();
            _this.props.resetQuotation();
            //history.push('/');
        })
        .catch(function (error) {
            console.log(error)
        });

    }

    showLogin(){
        const { history } = this.props;
        this.props.userLogout();
        this.props.resetOrder();
        this.props.resetQuotation();
        history.push('/');
    }


    onArticleNumberChange(e){
        this.setState({
            article_number: e.target.value
        });
    }

    onCheckArticleNumber(e){
        const _this = this;

        axios.post(_this.props.config.api_path+'api/getProductForArticleNumber', querystring.stringify({
            article_number: this.state.article_number,
            price_tier: this.props.user.price_tier
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {

            if(!response.data.success){
                _this.setState({
                    error_article_number: "format should be XXX-P-CL."
                });
            }else if(!response.data.product){
                _this.setState({
                    error_article_number: "No product found for given article number."
                });
            }else if(response.data.order.packaging_number != "?"){
                _this.setState({
                    error_article_number: false
                });

                if(response.data.order){
                    _this.props.setProductType({
                        product_type: response.data.order.product_type
                    });
                    _this.props.setConnectorType({
                        connector_type: response.data.order.connector_type
                    });
                    _this.props.setFiberType({
                        fiber_type: response.data.order.fiber_type
                    });
                    _this.props.setCableType({
                        cable_type: response.data.order.cable_type
                    });
                    _this.props.setCableLength({
                        cable_length: response.data.order.cable_length
                    });
                    _this.props.setPackagingType({
                        packaging_type: response.data.order.packaging_type
                    });
                }

                _this.props.setProduct({
                    product: response.data.product
                });

                setTimeout(function () {
                    _this.getConnectorTypes();
                    _this.getFiberTypes();
                    _this.getCableTypes();
                    _this.getPackagingTypes();
                }, 1000);

            }else {
                _this.setState({
                    error_article_number: "No Packaging found for given cable length."
                });
            }
        })
        .catch(function (error) {
            _this.setState({
                error_article_number: "No product found for given article number."
            });
        });
    }

    getConnectorTypes(){
        const _this = this;

        axios.post(_this.props.config.api_path+'api/getConnectorTypes', querystring.stringify({
            product_type: this.props.order.product_type
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {
            _this.props.setConnectorItems({
                items: response.data.types
            })
        })
            .catch(function (error) {
                console.log(error);
            });
    }

    getFiberTypes(connector_type){
        const _this = this;

        axios.post(_this.props.config.api_path+'api/getFiberTypes', querystring.stringify({
            product_type: this.props.order.product_type,
            connector_type: this.props.order.connector_type
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {
            _this.props.setFiberItems({
                items: response.data.types
            })
        })
            .catch(function (error) {
                console.log(error);
            });
    }

    getCableTypes(fiber_type){
        const _this = this;

        axios.post(_this.props.config.api_path+'api/getCableTypes', querystring.stringify({
            product_type: this.props.order.product_type,
            connector_type: this.props.order.connector_type,
            fiber_type: this.props.order.fiber_type
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {
            _this.props.setCableItems({
                items: response.data.types
            })
        })
            .catch(function (error) {
                console.log(error);
            });
    }

    getPackagingTypes(cable_length){
        const _this = this;

        axios.post(_this.props.config.api_path+'api/getPackaging', querystring.stringify({
            product_type: this.props.order.product_type,
            connector_type: this.props.order.connector_type,
            fiber_type: this.props.order.fiber_type,
            cable_type: this.props.order.cable_type,
            cable_length: this.props.order.cable_length
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {
            _this.props.setPackagingItems({
                items: response.data.types
            });
        })
            .catch(function (error) {
                console.log(error);
            });
    }

    render() {

        return (
            <div className="menu">
                <div className="logo">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         width="178.049px" height="81.625px" viewBox="0 0 178.049 81.625" enableBackground="new 0 0 178.049 81.625"
                         xmlSpace="preserve">
                        <g>
                            <g>
                                <g>
                                    <g>
                                        <g>
                                            <circle fill="#ffffff" cx="88.995" cy="29.963" r="26.931"/>
                                        </g>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <g>

                                            <path fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" d="
                                            M81.669,18.744c2.104-1.377,4.62-2.176,7.325-2.176c2.7,0,5.216,0.798,7.317,2.172"/>
                                        </g>
                                        <g>

                                            <path fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" d="
                                            M83.507,26.501l-5.631-4.011c-1.438,2.135-2.276,4.704-2.276,7.473c0,3.024,1.005,5.818,2.698,8.063"/>
                                        </g>
                                        <g>

                                            <path fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" d="
                                            M83.507,26.501"/>
                                        </g>
                                        <g>

                                            <path fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" d="
                                            M94.451,34.298"/>
                                        </g>
                                        <g>

                                            <path fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" d="
                                            M100.103,22.472c1.447,2.139,2.287,4.716,2.287,7.491c0,3.027-1.006,5.821-2.697,8.065l-5.241-3.73"/>
                                        </g>
                                        <g>

                                            <line fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" x1="88.994" y1="16.567" x2="88.994" y2="43.609"/>
                                        </g>
                                        <g>

                                            <circle fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" cx="88.994" cy="29.963" r="20.626"/>
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g>
                                <g>
                                    <g>
                                        <g>
                                            <polygon fillRule="evenodd" clipRule="evenodd" fill="#ffffff" points="7.917,75.457 9.994,64.906 20.101,64.906
                                            27.42,70.982 28.615,64.906 36.891,64.906 34.814,75.457 25.226,75.457 17.185,69.279 15.968,75.457 7.917,75.457 					"/>
                                            <polygon fillRule="evenodd" clipRule="evenodd" fill="#ffffff" points="38.897,75.457 40.733,64.906 59.34,64.906
                                            58.888,67.494 47.088,67.494 46.869,68.75 56.424,68.75 55.97,71.353 46.415,71.353 46.174,72.738 58.557,72.738
                                            58.085,75.457 38.897,75.457 					"/>
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#ffffff" d="M62.911,65.013h6.703l-0.944,5.079
                                            c-0.138,0.747-0.192,1.283-0.167,1.608c0.032,0.324,0.132,0.598,0.309,0.816c0.204,0.265,0.619,0.471,1.231,0.61
                                            s1.381,0.211,2.3,0.211c0.921,0,1.71-0.071,2.375-0.211c0.657-0.14,1.15-0.346,1.464-0.61c0.26-0.219,0.458-0.492,0.612-0.816
                                            c0.146-0.325,0.291-0.861,0.432-1.608l0.131-0.714l0.812-4.365h6.687l-1.027,5.522c-0.212,1.144-0.529,1.988-0.959,2.534
                                            c-0.429,0.545-1.061,1.007-1.909,1.395c-0.918,0.422-2.139,0.74-3.645,0.951c-1.511,0.213-3.317,0.317-5.416,0.317
                                            c-2.11,0-3.878-0.104-5.304-0.317c-1.427-0.211-2.53-0.529-3.303-0.951c-0.691-0.388-1.151-0.85-1.384-1.395
                                            c-0.227-0.546-0.236-1.391-0.023-2.534l0.202-1.086L62.911,65.013L62.911,65.013z"/>
                                            <polygon fillRule="evenodd" clipRule="evenodd" fill="#ffffff" points="90.532,75.457 92.056,67.482 86.455,67.482
                                            86.925,65.013 104.942,65.013 104.471,67.482 98.87,67.482 97.347,75.457 90.532,75.457 					"/>
                                            <polygon fillRule="evenodd" clipRule="evenodd" fill="#ffffff" points="131.16,75.457 133.095,64.906 141.05,64.906
                                            139.117,75.457 131.16,75.457 					"/>
                                            <polygon fillRule="evenodd" clipRule="evenodd" fill="#ffffff" points="142.867,75.457 145.064,65.013 152.473,65.013
                                            151.475,69.756 161.161,65.013 169.881,65.013 158.66,70.107 168.565,75.457 159.225,75.457 151.262,70.768 150.275,75.457
                                            142.867,75.457 					"/>
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#ffffff" d="M105.548,75.457l1.659-10.443h8.326
                                            c3.256,0,5.522,0.054,6.785,0.161c1.266,0.106,2.347,0.287,3.24,0.538c1.003,0.283,1.755,0.649,2.251,1.09
                                            c0.494,0.443,0.696,0.931,0.612,1.463c-0.128,0.809-0.786,1.466-1.977,1.974c-1.19,0.506-2.865,0.841-5.017,1.007l7.288,4.211
                                            h-9l-6.053-4.088l-0.65,4.088H105.548L105.548,75.457z M113.891,69.949h1.477c1.717,0,2.987-0.104,3.812-0.313
                                            c0.823-0.211,1.27-0.54,1.341-0.985c0.083-0.522-0.226-0.895-0.933-1.116c-0.7-0.223-1.923-0.332-3.666-0.332h-1.596
                                            L113.891,69.949L113.891,69.949z"/>
                                        </g>
                                    </g>
                                </g>
                                <g>
                                    <rect x="171.714" y="65.013" fill="none" width="5.672" height="4.558"/>
                                    <path fill="#ffffff" d="M172.832,64.976c0.188,0,0.37,0.049,0.548,0.145s0.316,0.232,0.416,0.412
                                    c0.1,0.178,0.149,0.364,0.149,0.559c0,0.191-0.05,0.375-0.147,0.553s-0.234,0.314-0.411,0.412s-0.361,0.146-0.555,0.146
                                    c-0.192,0-0.377-0.049-0.554-0.146s-0.314-0.234-0.412-0.412c-0.099-0.178-0.147-0.361-0.147-0.553
                                    c0-0.194,0.05-0.381,0.149-0.559c0.1-0.18,0.238-0.316,0.417-0.412C172.463,65.025,172.646,64.976,172.832,64.976z
                                     M172.832,65.162c-0.156,0-0.309,0.039-0.456,0.119c-0.148,0.08-0.265,0.195-0.348,0.344c-0.084,0.15-0.126,0.305-0.126,0.467
                                    c0,0.16,0.041,0.313,0.124,0.461c0.082,0.146,0.196,0.262,0.344,0.344s0.302,0.123,0.462,0.123c0.161,0,0.314-0.041,0.462-0.123
                                    s0.263-0.197,0.344-0.344c0.082-0.147,0.123-0.301,0.123-0.461c0-0.162-0.042-0.316-0.125-0.467
                                    c-0.083-0.148-0.199-0.264-0.348-0.344S172.987,65.162,172.832,65.162z M172.344,66.707v-1.199h0.412
                                    c0.141,0,0.242,0.012,0.306,0.033c0.063,0.022,0.112,0.062,0.15,0.116c0.037,0.056,0.056,0.114,0.056,0.176
                                    c0,0.087-0.031,0.163-0.094,0.229s-0.146,0.102-0.248,0.109c0.042,0.018,0.076,0.039,0.102,0.063
                                    c0.048,0.047,0.107,0.127,0.177,0.237l0.146,0.235h-0.236l-0.106-0.189c-0.083-0.148-0.151-0.241-0.202-0.279
                                    c-0.035-0.027-0.087-0.041-0.155-0.041h-0.113v0.51H172.344z M172.537,66.032h0.234c0.112,0,0.189-0.017,0.229-0.05
                                    c0.041-0.033,0.062-0.078,0.062-0.133c0-0.035-0.01-0.067-0.029-0.096c-0.02-0.027-0.047-0.049-0.082-0.063
                                    s-0.1-0.021-0.194-0.021h-0.22V66.032z"/>
                                </g>
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </div>
                <div className="slogan">
                    <b>optical</b>CON Configurator
                </div>

                {this.props.order.product != null ?

                    <div>
                        <div className="product_name" onClick={() => this.showProductDetails()}>
                            Your current product: <br /><b>{this.props.order.product.number}</b>
                        </div>
                        <div className="opener product" onClick={() => this.showProductDetails()}>
                            <i className="fa fa-info"></i>
                        </div>
                    </div>
                    :
                    <div className="opener" onClick={() => this.showProductDetails()}>
                        <i className="fa fa-info"></i>
                    </div>
                }
                <div className="header_article_number_container">
                    <div className="manualArticleNumber">
                        {this.state.error_article_number !== false ?
                            <p className="article_number_error">{this.state.error_article_number}</p>
                            :
                            <label>Enter your article number</label>
                        }
                        <input type="text" name="article_number" id="ArticleNumber" onChange={(e) => this.onArticleNumberChange(e)}/>
                        <button onClick={(e) => this.onCheckArticleNumber(e)} ><i className="fa fa-check"></i></button>
                    </div>
                </div>
                {this.props.user.user != null ?
                    <div className="log logout" onClick={() => this.logout()}>
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                             xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             width="34px" height="30px" viewBox="0 0 34 30" enableBackground="new 0 0 34 30"
                             xmlSpace="preserve">
                            <path fillRule="evenodd" clipRule="evenodd" d="M31.342,28.455L20.645,28.98c-0.448,0.022-0.857-0.207-1.162-0.601h-4.168
                            c-1.258,0-2.277-1.019-2.277-2.277v-2.96h1.936v1.251c0,1.259,1.02,2.278,2.278,2.278h1.693c0-0.002,0-0.003,0-0.006l-0.14-22.997
                            h-1.554c-1.258,0-2.278,1.02-2.278,2.277v4.043h-1.936V4.181c0-1.257,1.02-2.278,2.277-2.278h3.813c0.308-0.584,0.807-0.94,1.37-0.9
                            l10.826,0.789c0.814,0.06,1.476,1.06,1.525,2.266c0,0.004,0,0.008,0.001,0.012c0,0.021,0,0.042,0.002,0.064
                            c0,0.016,0.001,0.031,0.001,0.047v0.024v21.897v0.024C32.853,27.372,32.177,28.414,31.342,28.455z M23.798,15.228
                            c0-1.227-0.688-2.221-1.538-2.221c-0.849,0-1.537,0.994-1.537,2.221s0.688,2.22,1.537,2.22
                            C23.11,17.447,23.798,16.454,23.798,15.228z M16.91,13.843v5.489c0,0.313-0.254,0.569-0.569,0.569h-6.126l0.004,2.198
                            c0,0-0.137,0.164-0.3,0.05c-1.344-0.95-7.542-5.01-7.551-5.521c-0.008-0.445,5.799-4.339,7.503-5.473
                            c0.293-0.195,0.479,0.114,0.479,0.114l0.002,2.003h5.989C16.656,13.273,16.91,13.529,16.91,13.843z"/>
                            <g>
                            </g>

                        </svg>

                    </div>
                    :
                    <div className="log login" onClick={() => this.showLogin()}>
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                             xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             width="34px" height="30px" viewBox="0 0 34 30" enableBackground="new 0 0 34 30"
                             xmlSpace="preserve">
                            <path fillRule="evenodd" clipRule="evenodd" d="M32.769,4.196c0.002,0.016,0.002,0.031,0.002,0.047V26.04l0,0v0.024
                		c0,1.237-0.67,2.273-1.503,2.314L20.633,28.9c-0.446,0.023-0.852-0.205-1.156-0.596h-4.145c-1.251,0-2.264-1.015-2.264-2.265v-1.047
                		l1.925-0.974v0.322c0,1.25,1.014,2.265,2.264,2.265h1.684c0-0.003,0-0.005,0-0.006L18.803,3.732h-1.545
                		c-1.25,0-2.264,1.014-2.264,2.265v3.154l-1.925-0.974V4.243c0-1.251,1.013-2.265,2.264-2.265h3.791
                		c0.306-0.581,0.802-0.937,1.362-0.896L31.25,1.867c0.81,0.059,1.468,1.054,1.518,2.253c0,0.004,0,0.008,0,0.012
                		C32.769,4.153,32.769,4.175,32.769,4.196z M23.769,15.226c0-1.22-0.685-2.208-1.529-2.208c-0.844,0-1.528,0.988-1.528,2.208
                		c0,1.22,0.684,2.208,1.528,2.208C23.084,17.434,23.769,16.446,23.769,15.226z M18.504,16.641c0.008,0.443-5.766,4.313-7.46,5.441
                		c-0.292,0.194-0.476-0.113-0.476-0.113l-0.002-1.992H4.609c-0.313,0-0.566-0.254-0.566-0.566v-5.457
                		c0-0.313,0.254-0.566,0.566-0.566h6.092L10.698,11.2c0,0,0.135-0.162,0.297-0.048C12.333,12.096,18.495,16.132,18.504,16.641z"/>
                            <g>
                            </g>
                        </svg>


                    </div>
                }
                {this.props.user.user != null &&
                <div className="basket" onClick={() => this.showBasket()}>

                    {this.props.cart.items.length > 0 &&
                        <div className="shopcart-badge">{this.props.cart.items.length}</div>
                    }

                    <svg version="1.1" id="shopcart" xmlns="http://www.w3.org/2000/svg"
                         xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 19.25 19.25" style={{enableBackground: 'new 0 0 19.25 19.25'}}
                         xmlSpace="preserve">

                        <path style={{fill: '#ffffff'}} d="M19.006,2.97c-0.191-0.219-0.466-0.345-0.756-0.345H4.431L4.236,1.461
                            C4.156,0.979,3.739,0.625,3.25,0.625H1c-0.553,0-1,0.447-1,1s0.447,1,1,1h1.403l1.86,11.164c0.008,0.045,0.031,0.082,0.045,0.124
                            c0.016,0.053,0.029,0.103,0.054,0.151c0.032,0.066,0.075,0.122,0.12,0.179c0.031,0.039,0.059,0.078,0.095,0.112
                            c0.058,0.054,0.125,0.092,0.193,0.13c0.038,0.021,0.071,0.049,0.112,0.065c0.116,0.047,0.238,0.075,0.367,0.075
                            c0.001,0,11.001,0,11.001,0c0.553,0,1-0.447,1-1s-0.447-1-1-1H6.097l-0.166-1H17.25c0.498,0,0.92-0.366,0.99-0.858l1-7
                            C19.281,3.479,19.195,3.188,19.006,2.97z M17.097,4.625l-0.285,2H13.25v-2H17.097z M12.25,4.625v2h-3v-2H12.25z M12.25,7.625v2
                            h-3v-2H12.25z M8.25,4.625v2h-3c-0.053,0-0.101,0.015-0.148,0.03l-0.338-2.03H8.25z M5.264,7.625H8.25v2H5.597L5.264,7.625z
                             M13.25,9.625v-2h3.418l-0.285,2H13.25z"/>
                        <circle style={{fill: '#ffffff'}} cx="6.75" cy="17.125" r="1.5"/>
                        <circle style={{fill: '#ffffff'}} cx="15.75" cy="17.125" r="1.5"/>
                    </svg>
                </div>
                }
            </div>
        );

    }

}

Header = withRouter(Header);

const mapStateToProps = state => ({
    routing: state.routing,
    config: state.config,
    order: state.order,
    user: state.user,
    cart: state.cart
})

const mapDispatchToProps = dispatch => bindActionCreators({
    userLogout,
    resetOrder,
    setProductType,
    setConnectorType,
    setFiberType,
    setCableType,
    setCableLength,
    setPackagingType,
    setProduct,
    setConnectorItems,
    setFiberItems,
    setCableItems,
    setPackagingItems,
    resetQuotation
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header)


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/containers/app/header.js